<template>
  <div class="lineData" :class="{bgPicter:!isNodata}">
    <v-chart :options="lineData" id="echart10" auto-resize></v-chart>
    <div
      class="no-chart-data"
      style="color:#D3D3D3;font-size:20px;"
      v-show="isNodata"
    >Temporarily no data</div>
  </div>
</template>

<script>
let setOption = () => {
  let lineColor = [
    "#63b2ee",
    "#FFAD5C",
    "#FF9F7F",
    "#FFDB5C",
    "#E7BCF3",
    "#E062AE",
    "#9084FF",
    "#12e78c",
    "#fe8104",
    "#8A2BE2",
    "#DC143C",
    "#fe3199",
    "#fef312",
    "#3f74fe",
    "#8A2BE2"
  ];
  let result = [];
  for (let i = 0; i < lineColor.length; i++) {
    result.push({
      type: "line",
      smooth: true,
      itemStyle: {
        normal: {
          lineStyle: {
            width: 2 //设置线条粗细
          }
        }
      }
    });
  }
  return result;
};

export default {
  name: "lineData",
  props: ["echartsData", "isNodata"],
  mounted() {
    this.setOptions();
    window.addEventListener("resize", () => {
      this.myChart2.resize();
    });
  },
  data() {
    return {
      lineData: {},
      myChart2: ""
    };
  },
  methods: {
    setOptions() {
      let echarts = require("echarts");
      let newResultData = this.$lodash.cloneDeep(
        JSON.parse(JSON.stringify(this.echartsData))
      );
      if (newResultData && newResultData.length > 0) {
        newResultData[1].map((item, index) => {
          item = Object.assign(item, setOption()[index]);
        });
        this.lineData = this.getOptions(newResultData);
      }
      this.myChart2 = echarts.init(document.getElementById("echart10"));
    },
    getOptions(seriesData) {
      let xAxisVal = JSON.parse(JSON.stringify(seriesData[0]));
      let AseriesData = JSON.parse(JSON.stringify(seriesData[1]));

      return {
        toolbox: {
          //工具栏(下载)
          feature: {
            saveAsImage: {
              show: true,
              title: "Save as picture"
            }
          },
          right: "5%"
        },
        color: [
          "#26DAD0",
          "#31DC72",
          
          "#FF6383",
          "#C95FF2",
          "#7C6AF2",
          "#5C89FF",
          "#13BAED",
          "#5CB3FF",
          "#8290FF",
          "#EF6BBB",
          "#FF7979",
          "#EBE300",
          "#26E7C7",
          "#FF9F40",
        ],
        //title: {
        // text: "",
        // show: this.echartsData[0].length === 0,
        // textStyle: {
        //   color: 'LightGrey',
        //   fontSize: 20
        // },
        // text: 'Temporarily no data',
        // left: 'center',
        // top: 'center'
        //},
        title: {
          text: "Trend of User's Attention",
          show: false
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          left: 20,
          top: 5,
          icon: "roundRect",
          orient: "horizontal", // horizontal     vertical
          // itemWidth && itemHeight 同时设置更改大小
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 20
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            // boundaryGap: false,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#DFDFDF",
                width: 1
              }
            },
            axisLabel: {
              fontSize: 12,
              textStyle: {
                color: "#00000",
                fontWeight: 1,
                fontFamily: "RCR"
              }
              // interval: 0,
              // rotate: 60 //倾斜度
            },
            data: xAxisVal || []
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#DFDFDF",
                width: 1
              }
            },
            splitLine: {
              show: false
            },
            // y axios 字体设置
            axisLabel: {
              fontSize: 12,
              textStyle: {
                color: "#00000",
                fontWeight: 1,
                fontFamily: "RCR"
              }
            }
          }
        ],
        series: AseriesData || []
      };
    }
  },
  watch: {
    echartsData(val) {
      this.setOptions();
    }
  }
};
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
.lineData {
  position: relative;
}
.lineData .no-chart-data {
  width: 300px;
  font-size: 25;
  font-weight: 600;
  position: absolute;
  left: 60%;
  right: 50%;
  transform: translate(-50%, -588%);
}
/* .lineData {
  margin-top: 30px;
} */
</style>
